import { Badge } from '@/components/ui/badge';

export function VersionBadge() {
  // Variables d'entorn injectades durant el build
  const version = import.meta.env.VITE_APP_VERSION || '1.0.0-beta';
  const buildDate = import.meta.env.VITE_BUILD_DATE;
  const isDev = version === 'dev' || !buildDate;
  
  // Formatear data si existeix i és vàlida
  let formattedDate = 'Dev build';
  if (buildDate) {
    const date = new Date(buildDate);
    if (!isNaN(date.getTime())) {
      formattedDate = date.toLocaleDateString('ca-ES', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    }
  }
  
  // Determinar entorn
  let environment = '🚀 Producció';
  if (isDev) environment = '⚙️  Entorn de desenvolupament';
  
  // Tooltip amb informació
  const tooltipLines = [
    `📦 Versió: ${version}`,
    `📅 Build: ${formattedDate}`,
    environment,
    `🔗 Click per veure releases`
  ];
  const tooltipText = tooltipLines.join('\n');

  return (
    <div 
      className="flex flex-col gap-0.5 cursor-pointer group" 
      title={tooltipText}
      onClick={() => window.open('https://github.com/guilleumes/GUILLEUMES_2026/releases', '_blank')}
    >
      <Badge 
        variant="outline" 
        className="text-xs font-mono w-fit border-gray-300 text-gray-600 group-hover:border-blue-400 group-hover:text-blue-600 transition-colors"
      >
        {version}
      </Badge>
      <span className="text-[10px] text-gray-400 font-normal group-hover:text-blue-500 transition-colors">
        {formattedDate}
      </span>
    </div>
  );
}
